import {connect} from "react-redux";
import Accepted from "./Accepted";
import {getOrder} from "../GlobalReduxState/action";

const mapStateToProps = (state :any)=>({
    feed: state.globalReducer.order,
    passedData: state.registerReducer.data,
    cssStyles: state.globalReducer.styles
});

const mapDispatchToProps = (dispatch:any)=>({
    callGetOrder: (domainId: any) => dispatch(getOrder(domainId)),
});

export default connect(mapStateToProps,mapDispatchToProps)(Accepted);
